import { Typography } from '@material-ui/core';
import { Fragment } from 'react';
import useATeamStyles from './styles/ateam-anim.styles';
import { animated as a } from 'react-spring';
import { useTranslation } from 'src/app/i18n';
import LinkedInIcon from 'src/assets/icons/common/LinkedInIcon';
import Link from 'next/link';
import { GreenTitleTypo, TitleTypo } from './StyledComponent';

import { LEADERS_INFO, REMAINING_KEY } from './services/constants';

import { useAnimationValues } from './services/animatinos';
import clsx from 'clsx';

interface Props {}

const ATeamAnimation = ({}: Props) => {
    const classes = useATeamStyles();

    const { t } = useTranslation('common');

    const [
        {
            topToTopLabel,
            topToBottomLabel,
            bottomToTopLabel,
            bottomTobottomLabel,
            plusLabel,
            minusLabel,
            height,
            transform,
            titleTranslate,
            labelOpacity
        },
        finished
    ] = useAnimationValues();

    return (
        <div className={classes.root}>
            <Typography variant="caption" color="textPrimary" className={classes.hide}>
                    {t('about.aTeam')}
                </Typography>
            <a.div style={{ transform: titleTranslate }} className={classes.ateamContainer}>
                <Typography variant="h5" color="textPrimary" className={classes.ateam}>
                    {t('about.aTeam')}
                </Typography>
            </a.div>

            <div className={classes.animatedContainer}>
                <div className={classes.animatedDiv}>
                    {LEADERS_INFO.map(({ name, link, pos }, idx) => (
                        <Fragment key={`${name}-${idx}`}>
                            {REMAINING_KEY.includes(idx) ? (
                                <div
                                    className={clsx({
                                        [classes.firstInfoItem]: idx === REMAINING_KEY[0]
                                    })}>
                                    <div className={classes.labelsContainer}>
                                        <a.div
                                            style={{ transform: plusLabel }}
                                            className={classes.firstLabel}>
                                            <Typography
                                                color="textPrimary"
                                                variant="h5"
                                                className={clsx(classes.mainText)}>
                                                {name}
                                            </Typography>
                                        </a.div>
                                        <a.div style={{ transform: minusLabel }}>
                                            <GreenTitleTypo className={clsx(classes.mainText)}>
                                                {pos}
                                            </GreenTitleTypo>
                                        </a.div>
                                    </div>

                                    <a.div
                                        key={name}
                                        className={clsx(classes.infoContainer)}
                                        style={{ height, transform }}>
                                        <img
                                            src={`/images/leads/${name}.png`}
                                            className={classes.leaderImage}
                                        />
                                        <div className={classes.leadersInfoDesc}>
                                            <Typography variant="body1" color="textPrimary">
                                                {t(`apsy.${name}`)}
                                            </Typography>
                                            <Link href={link}>
                                                <a className={classes.linkedin}>
                                                    <LinkedInIcon
                                                        className={classes.linkedinIcon}
                                                    />
                                                </a>
                                            </Link>
                                        </div>
                                    </a.div>
                                </div>
                            ) : (
                                !finished && (
                                    <div
                                        className={clsx(
                                            classes.mainText,
                                            classes.absoluteLabelContainer
                                        )}
                                        style={{
                                            top: idx * 80
                                        }}>
                                        <a.div
                                            className={classes.firstLabel}
                                            style={{
                                                opacity:labelOpacity,
                                                transform:
                                                    idx > REMAINING_KEY[2]
                                                        ? topToBottomLabel
                                                        : topToTopLabel
                                            }}>
                                            <TitleTypo>{name}</TitleTypo>
                                        </a.div>
                                        <a.div
                                            style={{
                                                transform:
                                                    idx > REMAINING_KEY[2]
                                                        ? bottomTobottomLabel
                                                        : bottomToTopLabel
                                            }}>
                                            <GreenTitleTypo>{pos}</GreenTitleTypo>
                                        </a.div>
                                    </div>
                                )
                            )}
                        </Fragment>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ATeamAnimation;
